module.exports = __webpack_public_path__ + "img/sx.9d5450f7.svg";